var Resource = /** @class */ (function () {
    function Resource(props) {
        Object.assign(this, props);
    }
    return Resource;
}());
export default Resource;
// @ts-ignore
var TypeResource = 'vehicle' | 'room' | 'bed' | 'boat' | 'atv' | 'slot';
// @ts-ignore
var typeBookinMode = 'exclusive' | 'shared';
// @ts-ignore
var TypeTouraroundTime = 'minutes' | 'hours';



//////////////////
// WEBPACK FOOTER
// ./src/modules/Resources/Resource.ts
// module id = 762
// module chunks = 0